import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const getStats = () => http.get("/stats").then((r) => r.data);
export const getLocks = (wallet) => http.get("/locks", { params: { wallet } }).then((r) => r.data);
export const createLock = (payload) => http.post("/locks", payload).then((r) => r.data);
export const getUnlockSchedule = (wallet) => http.get("/unlock-schedule", { params: { wallet } }).then((r) => r.data);
export const getNextUnlock = (wallet) => http.get("/next-unlock", { params: { wallet } }).then((r) => r.data);
export const getActivity = (wallet) => http.get("/activity", { params: { wallet } }).then((r) => r.data);
export const getPortfolio = (wallet) => http.get("/portfolio", { params: { wallet } }).then((r) => r.data);
export const multisendPreview = (payload) => http.post("/multisender/preview", payload).then((r) => r.data);
export const multisendExecute = (payload) => http.post("/multisender/execute", payload).then((r) => r.data);
export const getKeys = (wallet) => http.get("/agent/keys", { params: { wallet } }).then((r) => r.data);
export const createKey = (payload) => http.post("/agent/keys", payload).then((r) => r.data);
export const revokeKey = (id) => http.delete(`/agent/keys/${id}`).then((r) => r.data);
export const getUsage = (wallet) => http.get("/agent/usage", { params: { wallet } }).then((r) => r.data);
export const getEndpoints = () => http.get("/agent/endpoints").then((r) => r.data);

export const verifyToken = (token) =>
  http.get("/me", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const fmtUsd = (n) => {
  if (n == null) return "$0";
  if (n >= 1e9) return "$" + (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return "$" + (n / 1e6).toFixed(2) + "M";
  if (n >= 1e3) return "$" + (n / 1e3).toFixed(1) + "K";
  return "$" + n.toFixed(2);
};

export const fmtNum = (n) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(n || 0);

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}...${a.slice(-4)}` : "");
